import React from 'react';
import Proptypes from 'prop-types';

import { MBox } from '../../../../../atoms/MBox';
import { MImageCarousel } from '../../../../../atoms/MImageCarousel';
import { MText } from '../../../../../atoms/MText';

import PriceDetails from '../../../../../molecules/PriceDetails';
import ProductActionButtons from '../../../../../molecules/ProductActionButtons';

import { StyledSlideoutLineProductItemCon } from './skins';

export default function SlideoutLineProduct(props) {
  const {
    isMobile,
    product,
    selectedVariant,
    theme,
    priceDetailStyles,
    getProductAndSelectedVariantData,
    productActionButtonStyles,
    productImageDimensions,
  } = props;

  // destructuring curr product item and selected variant data
  // go to function defination for each variable info
  const {
    images,
    offerPrice,
    price,
    off,
    isDiscountDisabled,
    onProductImageClick,
    onProductTitleClick,
    handleVariantChange,
    onAddClick,
    quantityAdded,
    variantOptions,
    showVariantSelector,
    showATCButton,
    withoutFirstAction,
    isProductAdditionEnabled,
    variantFiller,
    variantFillerStyles,
    isQtyAdditionEnabled,
    variantAtcStatus,
    isMaxQtyAdded,
  } = getProductAndSelectedVariantData(product, selectedVariant);

  const productActionButtonsProps = {
    quantityAdded,
    showVariantSelector,
    showATCButton,
    withoutFirstAction,
    isProductAdditionEnabled,
    variantFiller,
    variantFillerStyles,
    variantSelectorValue: selectedVariant.title,
    variantSelectorOptions: variantOptions,
    handleVariantChange,
    onAddClick,
    isQtyAdditionEnabled,
    variantAtcStatus,
    isMaxQtyAdded,
    ...productActionButtonStyles,
  };

  return (
    <>
      <StyledSlideoutLineProductItemCon
        padding={
          isMobile ? theme.productItemMobilePadding : theme.productItemPadding
        }
        margin={
          isMobile ? theme.productItemMobileMargin : theme.productItemMargin
        }
        className={`mr-product-item mr-product-item--cross-sell-popup mr-product-item--${
          theme.popupType
        }-${
          isMobile ? theme.popupMobileLayoutType : theme.popupDesktopLayoutType
        }`}
      >
        <MBox className="mr-product-item__body-wrapper">
          <MImageCarousel
            images={images}
            imageWidth={
              isMobile
                ? productImageDimensions.mobileWidth
                : productImageDimensions.width
            }
            imageHeight={
              isMobile
                ? productImageDimensions.mobileHeight
                : productImageDimensions.height
            }
            imageMobileWidth={productImageDimensions.mobileWidth}
            imageMobileHeight={productImageDimensions.mobileHeight}
            imageIsBordered={theme.isProductImageBordered}
            imageBorderColor={theme.productImageBorderColor}
            imageBorderWidth={theme.productImageBorderWidth}
            imageBorderRadius={
              isMobile
                ? theme.productImageMobileBorderRadius
                : theme.productImageBorderRadius
            }
            imagePadding={theme.productImagePadding}
            imageMargin={theme.productImageMargin}
            arrowColor={productActionButtonStyles.atcButtonBackgroundColor}
            imageIndex={selectedVariant.image_index}
            onImageClick={onProductImageClick}
          />
          <MBox
            padding={theme.productItemBodyPadding}
            margin={theme.productItemBodyMargin}
            className="mr-product-item__body"
          >
            <MBox className="mr-product-body__details">
              <MText
                color={theme.productNameTextColor}
                fontSize={
                  isMobile
                    ? theme.productNameMobileFontSize
                    : theme.productNameFontSize
                }
                mobileFontSize={theme.productNameMobileFontSize}
                fontStyle={theme.productNameFontStyle}
                fontWeight={theme.productNameFontWeight}
                textDecoration={theme.productNameTextDecoration}
                fontFamily={theme.productNameFontFamily}
                textAlignment={
                  isMobile
                    ? theme.productNameMobileTextAlignment
                    : theme.productNameTextAlignment
                }
                padding={
                  isMobile
                    ? theme.productNameMobilePadding
                    : theme.productNamePadding
                }
                margin={
                  isMobile
                    ? theme.productNameMobileMargin
                    : theme.productNameMargin
                }
                className="mr-product-details__product-title"
                onTextClick={onProductTitleClick}
                cursor={theme.isProductTitleClickGoToPage ? 'pointer' : 'auto'}
              >
                {product.title}
              </MText>
              {product.description && (
                <MText
                  color={theme.productDescriptionTextColor}
                  fontSize={
                    isMobile
                      ? theme.productDescriptionMobileFontSize
                      : theme.productDescriptionFontSize
                  }
                  mobileFontSize={theme.productDescriptionMobileFontSize}
                  fontStyle={theme.productDescriptionFontStyle}
                  fontWeight={theme.productDescriptionFontWeight}
                  textDecoration={theme.productDescriptionTextDecoration}
                  fontFamily={theme.productDescriptionFontFamily}
                  textAlignment={
                    isMobile
                      ? theme.productDescriptionMobileTextAlignment
                      : theme.productDescriptionTextAlignment
                  }
                  padding={theme.productDescriptionPadding}
                  margin={theme.productDescriptionMargin}
                  className="mr-product-details__product-description"
                >
                  {product.description}
                </MText>
              )}
              <PriceDetails
                offerPrice={offerPrice}
                price={price}
                off={off}
                isDiscountDisabled={isDiscountDisabled}
                {...priceDetailStyles}
                textAlignment={
                  isMobile
                    ? theme.productPriceMobileTextAlignment
                    : theme.productPriceTextAlignment
                }
                fontFamily={theme.productPriceFontFamily}
                margin={
                  isMobile
                    ? theme.productPriceMobileMargin
                    : theme.productPriceMargin
                }
                padding={
                  isMobile
                    ? theme.productPriceMobilePadding
                    : theme.productPricePadding
                }
                className="mr-product-item__price-con"
              />
              <ProductActionButtons
                layout="vertical"
                {...productActionButtonsProps}
              />
            </MBox>
          </MBox>
        </MBox>
      </StyledSlideoutLineProductItemCon>
    </>
  );
}

SlideoutLineProduct.propTypes = {
  isAdmin: Proptypes.bool.isRequired,
  isAdminMobileTab: Proptypes.bool.isRequired,
  isMobile: Proptypes.bool.isRequired,
  product: Proptypes.object.isRequired,
  selectedVariant: Proptypes.object.isRequired,
  theme: Proptypes.object.isRequired,
  getProductAndSelectedVariantData: Proptypes.func.isRequired,
  priceDetailStyles: Proptypes.object,
  productActionButtonStyles: Proptypes.object,
  productImageDimensions: Proptypes.object,
};
